import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Alert, Spin, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, CloudServerOutlined } from '@ant-design/icons';
import { login } from '../api/auth';
import { setToken, setUserInfo, isLoggedIn } from '../utils/auth';
import './Login.css';

const { Text, Paragraph } = Typography;

const API_BASE = import.meta.env.VITE_API_BASE || '';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  // 检查是否已登录
  useEffect(() => {
    const checkLogin = async () => {
      const loggedIn = await isLoggedIn();
      if (loggedIn) {
        onLogin();
      }
      setChecking(false);
    };
    checkLogin();
  }, [onLogin]);

  const handleSubmit = async (values) => {
    setLoading(true);
    setError('');

    try {
      const result = await login(values.username, values.password);
      
      if (result.success) {
        setToken(result.data.token);
        setUserInfo({
          username: result.data.username,
          name: result.data.name,
          permissions: result.data.permissions
        });
        message.success(`欢迎回来，${result.data.name}`);
        onLogin();
      } else {
        setError(result.error || '登录失败');
      }
    } catch (err) {
      setError('网络错误：' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 检查 API 配置
  const isEdgeOnePages = window.location.hostname.includes('pages.dev') || 
                         window.location.hostname.includes('123366.xyz');
  const showConfigWarning = !API_BASE && !isEdgeOnePages;

  if (checking) {
    return (
      <div className="login-container">
        <Spin size="large" tip="检查登录状态..." />
      </div>
    );
  }

  return (
    <div className="login-container">
      <Card className="login-card" title={
        <div className="login-title">
          <CloudServerOutlined className="login-icon" />
          <span>COS 管理后台</span>
        </div>
      }>
        {/* API 配置警告 */}
        {showConfigWarning && (
          <Alert
            message="API 未配置"
            description={
              <div>
                <Paragraph>
                  请在项目根目录创建 <Text code>.env</Text> 文件：
                </Paragraph>
                <Paragraph>
                  <pre style={{ background: '#f5f5f5', padding: 8, borderRadius: 4 }}>
                    VITE_API_BASE=https://your-api-gateway.tencentcs.com/release
                  </pre>
                </Paragraph>
                <Paragraph type="secondary">
                  然后将你的腾讯云 API 网关地址填入
                </Paragraph>
              </div>
            }
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={() => setError('')}
            style={{ marginBottom: 16 }}
          />
        )}

        <Form
          name="login"
          onFinish={handleSubmit}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
              autoFocus
              disabled={showConfigWarning}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              disabled={showConfigWarning}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              disabled={showConfigWarning}
            >
              登录
            </Button>
          </Form.Item>
        </Form>


      </Card>
    </div>
  );
};

export default Login;
